"use strict";

import React from 'react';
import {  _I_,  defineSimpleTerm  } from 'components/locs';
import {  classMixer  }  from  'generics/utils';
import { BootButton, CloseButton } from 'generics/buttons';
import { IconFontAwesome } from 'generics/icons';

export function TrivialDialog({
    prefixL10N,
    panelType="default",
    mixClasses=[],
    bodyIcon,

    onCloseButton,

    onOkButton,
    okButtonIcon="check",

    onDefaultButton,
    defaultButtonIcon="info",

    onCancelButton,
    cancelButtonIcon="times",

    children,
  })   {
    return (
        <div className={classMixer(`panel panel-${panelType} panel-sm`, ...mixClasses)} >
          <div className="panel-heading">
            {_I_(`${prefixL10N}.heading`)}
            {" "}
            {!!onCloseButton && <CloseButton onClick={onCloseButton} />}
          </div>

          <div className="panel-body">
            <div className="text-center"><b>{_I_(`${prefixL10N}.prompt`)}</b></div>

            {!!bodyIcon  &&  <div className="text-center">{bodyIcon}</div>}

            <div className="text-center pre">{_I_(`${prefixL10N}.explanation`)}</div>

            <div className="text-center">{children}</div>

            <div className="text-center">
              <div className="view-trivial-dialog-buttons">
                {!!onOkButton &&
                  <BootButton variant="success"  onClick={onOkButton}  >
                    <IconFontAwesome type={okButtonIcon} />
                    {" "}
                    {_I_(`${prefixL10N}.okButton`)}
                  </BootButton>}

                {!!onDefaultButton &&
                  <BootButton variant="primary"  onClick={onDefaultButton}  >
                    <IconFontAwesome type={defaultButtonIcon} />
                    {" "}
                    {_I_(`${prefixL10N}.defaultButton`)}
                  </BootButton>}

                {!!onCancelButton &&
                  <BootButton variant="warning"  onClick={onCancelButton}  >
                    <IconFontAwesome type={cancelButtonIcon} />
                    {" "}
                    {_I_(`${prefixL10N}.cancelButton`)}
                  </BootButton>}

              </div>
            </div>
          </div>
        </div>
      );
}

